import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {DatatableViewComponent} from '@ngx-ivengi/crud';
import {ConfirmationModalComponent} from '../confirmation/confirmation-modal.component';
import {Owner} from './owner.model';
import {OwnerService} from './owner.service';
import {UIRouter} from '@uirouter/angular';
import {RoutePrefix} from '../shared/route-prefix';

@Component({
  selector: 'app-owner-datatable',
  templateUrl: './owner-datatable.component.html'
})
export class OwnerDatatableComponent extends DatatableViewComponent<Owner> implements OnInit, OnDestroy {

  @ViewChild(ConfirmationModalComponent)
  public confirmationModal: ConfirmationModalComponent;

  @Input() public routePrefix: RoutePrefix | RoutePrefix[];

  constructor(
    private router: UIRouter,
    private ownerService: OwnerService
  ) {
    super(ownerService);
  }

  public ngOnInit(): void {
    if(this.routePrefix) {
      const prefixParts = (this.routePrefix instanceof Array) ? this.routePrefix : [this.routePrefix];

      const prefix  = prefixParts.map((item) => {
        return `${item.entity}/${item.entityId}`;
      });

      this.ownerService.setRoutePrefix(prefix.join('/').toLowerCase());
    }

    this.requestParams.addSortParam({key: 'name', value: 'asc'});
    this.fetchData();
  }

  public ngOnDestroy(): void {
    this.ownerService.clearRoutePrefix();
  }

  public deleteItem(item) {
    this.confirmationModal.show(item);
  }

  public onDeleteConfirmation(event) {
    if(event.confirmed === true) {
      this.ownerService.delete(event.data).subscribe(() => {
        this.router.stateService.go(this.router.stateService.$current.name, this.router.stateService.params, {reload: true});
      });
    }
  }

  public onRowClick(event) {
    if (event.type !== 'dblclick' || typeof event.column === 'undefined' || event.column.prop === 'menu' || typeof event.row === 'undefined') {
      return;
    }
    this.router.stateService.go('owner.edit', { id: event.row.id }, { reload: true });
  }}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/owner/owner-datatable.component.ts